AuthRoute = require 'mixins/authenticated-route'

###
# Single order route
###
module.exports = Em.Route.extend AuthRoute,
  realTimeService: Em.inject.service('realTime')
  session:         Em.inject.service('session')
  env:             Em.inject.service('environment')

  renderTemplate: (controller) ->
    @render 'orders.order',
      into: (if localStorage.getItem('lowPerformanceMode') == 'true' then 'application' else 'orders')
      outlet: (if localStorage.getItem('lowPerformanceMode') == 'true' then null else 'modal')
      controller: controller

  controllerName: 'ordersOrderModal'

  determineRouteContext: ->
    if _.isEmpty(@paramsFor('orders.map.order'))
      'list'
    else
      'map'

  currentController: ->
    if @determineRouteContext() is 'list'
      @controllerFor('orders.list.order')
    else
      @controllerFor('orders.map.order.detailed')

  updateOrderOpened: ->
    @get('realTimeService').broadcast({type: 'order_window_opened', order_id: @get('controller.model.id')})
    Em.run.later(@updateOrderOpened.bind(@), @get('env').get('orderViewedByInterval') || 5000)

  model : (params) ->
    order_id = params.order_id
    order_id = @paramsFor('orders.map.order').order_id unless order_id

    @store.fetchById('order', order_id)
    .then (order) =>
      # Подгружаем содержимое корзины
      order.get('client') # клиент иногда бывает недоступен, загружаем его асинхронно и без привязки к общему флоу
      order.get('buddies')
      .then (result) =>
        order

  actions:
    loading: ->
      @controllerFor('orders').set('isModalLoading', true)
      false

    error: ->
      @controllerFor('orders').set('isModalLoading', true)
      false

    didTransition: ->
      @controllerFor('orders').set('isModalLoading', false)
      order_id = @get('controller.model.id')
      @updateOrderOpened()
      @get('realTimeService').get('newOrderIds').removeObject(order_id) if order_id
      false

    closeModal: ->
      order = @get('controller.order')
      status = order.get('status')

      @get('realTimeService').broadcast({type: 'order_window_closed', order_id: order.id})

      # if status is 'draft'
      #   promise = new Ember.RSVP.Promise (resolve, reject) =>
      #     resolve(confirm("Удалить черновик заказа?"))

      #   promise.then (isDestroy) =>
      #     if isDestroy
      #       order.destroyRecord().then =>
      #         @send 'transitionToOrders', true
      #     else
      #       @send 'transitionToOrders'
      # else
      @send 'transitionToOrders'

      false

    transitionToOrders: (needReload)->
      if @determineRouteContext() is 'list'
        if needReload
          @controllerFor('orders.list').toggleProperty('manualRefresh')

        @transitionTo('orders.list')
      else
        @transitionTo('orders.map')
